import {
  finishCss,
  THEME_COLOR_TOKENS,
  themeCss,
  type FinishOptions,
  type ThemeFile,
} from '@base/shared';
import { useId } from 'react';
import { useSheet } from '../css-sheet.ts';

/** A letra da marca, quando o tema não troca (`font: base`). */
const BRAND_FONT = "'Geist Sans', ui-sans-serif, system-ui, sans-serif";

/**
 * O tema preso a um pedaço da tela (prévia). As classes do Tailwind (`bg-sheet`) leem
 * `--color-sheet`, que a raiz já resolveu com as cores atuais: por isso o pedaço redefine as duas.
 */
function scopedCss(theme: ThemeFile, scope: string, finish?: FinishOptions): string {
  const colorVars = THEME_COLOR_TOKENS.map((k) => `--color-${k}:var(--${k});`).join('');
  const font = theme.font === 'base' ? `--font-sans:${BRAND_FONT};` : '';
  // O acabamento da escolha preso ao pedaço (ADR 0133): as peças dentro leem estas variáveis.
  const finishVars = finish ? finishCss(finish, `.${scope}`) : '';
  return `${themeCss(theme, `.${scope}`)}${finishVars}.${scope}{${colorVars}${font}font-family:var(--font-sans);}`;
}

/** A classe que prende o tema a um pedaço da tela (a prévia do estúdio). */
export function useScope(theme: ThemeFile, prefix: string, finish?: FinishOptions): string {
  const scope = `${prefix}-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  useSheet(scopedCss(theme, scope, finish));
  return scope;
}
